import React from 'react'

const COLORS = ['#365f94', '#8faadc', '#424f60', '#ffc30c','#bbcce2','#7d5c94','#203864','#ed7d31','#4472c4','#34a4e4'];

const arr = [2,3,4,5,6,7,8,9,10,11]

const PieLegend = (props) => {
    const {_data} = props;
  return (
      <div className='flex flex-wrap gap-2 ml-1 text-xs'>
          {
              _data && _data.map((v, i) => {
                  return (
                      <div className='flex items-center gap-1 mb-2' key={i}>
                          <div className='w-3 h-3' style={{background:COLORS[i]}}></div>
                          <span>{v.name}(12%)</span>
                      </div>
                  )
              })
          }
      </div>
  )
}

export default PieLegend;